export default __webpack_public_path__ + "vendor/ckeditor/plugins/specialchar/dialogs/lang/_translationstatus.txt";